import classNames from 'classnames';
import { ComponentProps, forwardRef } from 'react';
import { PriceExtraction } from '../../../../../@types/IPA/PriceExtraction';
import { FilterButton, InnerFilter } from '../../../../../components';
import { isCascadingFilterKey } from '../../../../../components/NewFilterBox/data/cascadingFilters';
import { SegmentsPlaceholder } from '../../../../../components/NewFilterBox/Components';
import styles from './Filters.module.scss';
import { useFilters } from './useFilters';

export type FiltersProps = ComponentProps<'section'>;
type FilterKey = PriceExtraction['filtersKeys'];

const Filters = forwardRef<HTMLElement, FiltersProps>(({ className, ...props }, ref) => {
  const { data, value, queries, loading, cattegories, actions } = useFilters();

  return (
    <section {...props} ref={ref} className={classNames(styles.wrapper, className)}>
      <div>
        <InnerFilter
          type="check"
          placeholder="Produtos"
          data={data?.productIds ?? []}
          value={value?.productIds ?? []}
          isLoading={loading?.productIds}
          onChange={(value: string[]) => actions.handleChange('productIds', value)}
          onOpen={() => actions.handleOpen('productIds')}
          onClean={() => actions.handleClean('productIds')}
          onClose={() => actions.handleSearch('productIds', '')}
          onSearch={(query: string) => actions.handleSearch('productIds', query)}
          pasteValues
          search={queries?.productIds}
          onConfirmPasteValues={actions.handleConfirmPasteProducts}
        />
        <InnerFilter
          type="check"
          placeholder="Família"
          data={data?.productFamilyIds ?? []}
          value={value?.productFamilyIds ?? []}
          isLoading={loading?.productFamilyIds}
          onChange={(value: string[]) => actions.handleChange('productFamilyIds', value)}
          onOpen={() => actions.handleOpen('productFamilyIds')}
          onClean={() => actions.handleClean('productFamilyIds')}
          onClose={() => actions.handleSearch('productFamilyIds', '')}
          onSearch={(query: string) => actions.handleSearch('productFamilyIds', query)}
        />
        <InnerFilter
          type="check"
          placeholder="Lojas"
          data={data?.storeIds ?? []}
          value={value?.storeIds ?? []}
          isLoading={loading?.storeIds}
          onChange={(value: string[]) => actions.handleChange('storeIds', value)}
          onClean={() => actions.handleClean('storeIds')}
          onClose={() => actions.handleSearch('storeIds', '')}
          onSearch={(query: string) => actions.handleSearch('storeIds', query)}
          selectAll={{
            onSelectAll: checked => {
              actions.handleSelectAll('storeIds', checked);
            },
          }}
        />
        <InnerFilter
          type="check"
          placeholder="Cluster"
          data={data?.clusters ?? []}
          value={value?.clusters ?? []}
          isLoading={loading?.clusters}
          onChange={(value: string[]) => {
            actions.handleChange('clusters', value);
          }}
          onClean={() => actions.handleClean('clusters')}
          onClose={() => actions.handleSearch('clusters', '')}
          onSearch={(query: string) => actions.handleSearch('clusters', query)}
        />
        <InnerFilter
          type="check"
          placeholder="Tipo de loja"
          data={data?.storeTypes ?? []}
          value={value?.storeTypes ?? []}
          isLoading={loading?.storeTypes}
          onChange={(value: string[]) => {
            actions.handleChange('storeTypes', value);
          }}
          onClean={() => actions.handleClean('storeTypes')}
          onClose={() => actions.handleSearch('storeTypes', '')}
          onSearch={(query: string) => actions.handleSearch('storeTypes', query)}
        />
        <InnerFilter
          type="check"
          placeholder="Segmentação"
          data={data.segmentos ?? []}
          value={value.segmentos}
          isLoading={loading.segmentos}
          onSearch={(query: string) => actions.handleSearch('segmentos', query)}
          onChange={(value: string[]) => actions.handleChange('segmentos', value)}
          onClose={() => actions.handleSearch('segmentos', '')}
          onClean={() => actions.handleClean('segmentos')}
          groupBy="role"
          searchable={false}
        />
        <FilterButton onClick={actions.handleCleanAll}>Limpar Filtros</FilterButton>
      </div>
      <div>
        {cattegories.map(({ value: key, level, name }) => (
          <InnerFilter
            key={key}
            type="check"
            data={data[key as FilterKey] ?? []}
            value={value[key as FilterKey]}
            onSearch={(query: string) => actions.handleSearch(key as FilterKey, query)}
            onChange={(value: string[]) => actions.handleChange(key as FilterKey, value)}
            onOpen={isCascadingFilterKey(key) ? () => actions.handleOpen(key as FilterKey) : undefined}
            onClose={() => actions.handleSearch(key, '')}
            onClean={() => actions.handleClean(key as FilterKey)}
            isLoading={loading.cattegories}
            placeholder={<SegmentsPlaceholder level={level} placeholder={name} />}
          />
        ))}
      </div>
    </section>
  );
});

Filters.displayName = 'Filters';

export { Filters };
